import { AnimatePresence } from "motion/react"

import AnimateInFlex, { ANIMATION_BY_KEY } from "#blocks/AnimateInFlex"
import Flex from "#blocks/Flex"
import { SFormHeader } from "#blocks/Form/formComponents"
import LinkButton from "#blocks/LinkButton"
import TextOverrun from "#blocks/TextOverrun"
import { useThemeContext } from "#contexts/ThemeContextProvider"
import { Uuid } from "#customTypes/globalTypes"

interface ClickableSessionNameListProps<T> {
  title: string
  items: T[] | null
  onClick: (id: Uuid) => void
  isLink?: boolean
}

const ClickableSessionNameList = <T extends { label: string; id: Uuid }>({
  title,
  items,
  onClick,
  isLink,
}: ClickableSessionNameListProps<T>) => {
  const { disabled } = useThemeContext()

  return (
    <Flex
      col
      gap={2}
      style={{
        justifyContent: "flex-start",
        width: 200,
      }}
    >
      <SFormHeader style={{ color: items?.length ? "inherit" : disabled }}>
        {title}
      </SFormHeader>
      <Flex col style={{ height: 200, overflowY: "auto", paddingRight: 12 }}>
        <AnimatePresence mode="popLayout">
          {items?.length ? (
            items?.map((item) =>
              isLink ? (
                <AnimateInFlex
                  key={`clickable-session-name-list-${item.id}`}
                  animationKey={`clickable-session-name-list-${item.id}`}
                  animation={ANIMATION_BY_KEY.leftSm}
                >
                  <LinkButton
                    onClick={() => onClick(item.id)}
                    style={{ minWidth: 0, width: "100%" }}
                  >
                    <TextOverrun text={item.label} />
                  </LinkButton>
                </AnimateInFlex>
              ) : (
                <AnimateInFlex
                  key={`clickable-session-name-list-${item.id}`}
                  animationKey={`clickable-session-name-list-${item.id}`}
                  animation={ANIMATION_BY_KEY.leftSm}
                >
                  {item.label}
                </AnimateInFlex>
              )
            )
          ) : (
            <AnimateInFlex
              animation={ANIMATION_BY_KEY.leftSm}
              style={{ color: disabled }}
            >
              None
            </AnimateInFlex>
          )}
        </AnimatePresence>
      </Flex>
    </Flex>
  )
}

export default ClickableSessionNameList
